import { render, staticRenderFns } from "./GuiaIndividual.vue?vue&type=template&id=08095fc3"
import script from "./GuiaIndividual.vue?vue&type=script&lang=js"
export * from "./GuiaIndividual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports